import { Pipe, PipeTransform } from '@angular/core';
import { CssClass, isNil, Nillable } from '@web/utils';
import { BodyRowCssClassFactory } from '../types/body-row-css-class-factory';

@Pipe({
  name: 'bodyRowCssClass',
  standalone: true,
})
export class BodyRowCssClassPipe<Item> implements PipeTransform {
  public transform(
    item: Item,
    bodyRowCassClassFn: Nillable<BodyRowCssClassFactory<Item>>,
  ): Nillable<CssClass> {
    if (isNil(bodyRowCassClassFn)) {
      return null;
    }

    return bodyRowCassClassFn(item);
  }
}
